import * as React from "react";

import { getFacebookAdAccounts } from "../api/integration";
import { FacebookAdAccount } from "../types/facebook";
import { useLoading } from "./loading";

export function useFacebookAdAccounts(workspace: string) {
  const [isLoadingFacebookAdAccounts, wrapIsLoadingFacebookAdAccounts] =
    useLoading();
  const [facebookAdAccounts, setFacebookAdAccounts] = React.useState<
    FacebookAdAccount[]
  >([]);
  const loadFacebookAdAccounts = React.useCallback(async () => {
    await wrapIsLoadingFacebookAdAccounts(async () => {
      setFacebookAdAccounts(await getFacebookAdAccounts(workspace));
    });
  }, [workspace, wrapIsLoadingFacebookAdAccounts]);

  return {
    facebookAdAccounts,
    isLoadingFacebookAdAccounts,
    loadFacebookAdAccounts,
  };
}
